import routes from '@/Router/routes.constants'

const alertPages = {
  dashboard: 'dashboard',
  transactions: 'transactions',
  transactionDetail: 'transaction_detail',
  shipments: 'shipments',
  shipmentDetail: 'shipment_detail',
  billing: 'billing',
  inventory: 'inventory',
  configuration: 'configuration',
}

export const alertPageRoutes = [
  {
    page: alertPages.shipments,
    paths: [
      routes.parcelsPage.index,
      routes.parcelsPage.outbound,
      routes.parcelsPage.inbound,
      routes.shipmentsMetricsPage,
    ],
  },
  {
    page: alertPages.shipmentDetail,
    paths: [routes.parcelDetailPage],
  },
  {
    page: alertPages.transactions,
    paths: [routes.transactionsPage, routes.merchantTransactionsPage],
  },
  {
    page: alertPages.transactionDetail,
    paths: [routes.transactionDetailPage, routes.merchantTransactionsTransactionDetailPage],
  },
  {
    page: alertPages.billing,
    paths: [routes.billingPage],
  },
  {
    page: alertPages.inventory,
    paths: [routes.inventoryPage.index],
  },
  {
    page: alertPages.configuration,
    prefix: true,
    paths: [routes.configurationPage.index, routes.merchantConfigurationPage.index],
  },
  {
    page: alertPages.dashboard,
    paths: [routes.dashboardPage, routes.merchantDashboardPage],
  },
]
